import { DataTableSelectionCheckbox } from 'design-system';

import type { SymbolKey } from '@/entities/symbol';
import type { SymbolPreviewPresentation } from '@/features/_shared/symbol-preview-registry';

import { useSelectionFunctions } from '../hooks/useSelectionFunctions';

export const SymbolCheckbox = ({
  presentation: _presentation,
  symbol
}: {
  presentation: SymbolPreviewPresentation;
  symbol: SymbolKey;
}) => {
  const { isSymbolSelected, toggleSymbolInSelection, isSpotLocked } = useSelectionFunctions();
  const checked = isSymbolSelected(symbol);

  return (
    <DataTableSelectionCheckbox
      aria-label={`Select ${symbol.Code}`}
      snapshot={{
        checked,
        disabled: false,
        indeterminate: false,
        locked: isSpotLocked
      }}
      onToggle={() => toggleSymbolInSelection(symbol)}
    />
  );
};

export const SelectAllToggle = ({ symbols }: { symbols: SymbolKey[] }) => {
  const {
    areAllSymbolsSelected,
    areAnySymbolsSelected,
    addSymbolsToSelection,
    removeSymbolsFromSelection,
    isSpotLocked
  } = useSelectionFunctions();
  const allSelected = areAllSymbolsSelected(symbols);
  const someSelected = areAnySymbolsSelected(symbols);

  return (
    <DataTableSelectionCheckbox
      aria-label='Select all symbols'
      snapshot={{
        checked: allSelected,
        disabled: symbols.length === 0,
        indeterminate: someSelected && !allSelected,
        locked: isSpotLocked
      }}
      onToggle={checked => {
        if (checked) {
          addSymbolsToSelection(symbols);
        } else {
          removeSymbolsFromSelection(symbols);
        }
      }}
    />
  );
};
